import { useEffect } from "react"

const ANSWER_WINDOW_MS = 30 * 1000

// Outside the components: the home's list header remounts its children on
// every render of the screen, which would forget the press.
const pressesAwaitingReload = new Map()

// GO answers on what is loaded. When that holds no live today it may be stale
// (loaded before midnight, before a reschedule): reload, then `answer` once
// more on the fresh data — only if it arrives within the window and the
// screen can still answer (in front, not in a live). A failed reload answers
// nothing: the app already says the network failed.
export function useReloadBeforeRefusing({
    key,
    data,
    isReloading,
    reload,
    answer,
    canAnswer,
}) {
    useEffect(() => {
        const press = pressesAwaitingReload.get(key)
        if (!press || isReloading) return
        if (Date.now() - press.at > ANSWER_WINDOW_MS) {
            pressesAwaitingReload.delete(key)
            return
        }
        // Not reloaded yet, or the reload failed: the window settles it.
        if (data === press.data) return
        // Every banner shares one key: an instance that cannot answer leaves
        // the press to the one in front, and the window drops it otherwise.
        if (!canAnswer) return
        pressesAwaitingReload.delete(key)
        answer()
    }, [isReloading, data])

    return {
        reloadThenAnswer: () => {
            // A press whose card went away is never read again: drop it.
            for (const [pressKey, press] of pressesAwaitingReload) {
                if (Date.now() - press.at > ANSWER_WINDOW_MS) {
                    pressesAwaitingReload.delete(pressKey)
                }
            }
            pressesAwaitingReload.set(key, { data, at: Date.now() })
            reload()
        },
        isReloadingForGo: pressesAwaitingReload.has(key) && !!isReloading,
    }
}
